<template>
<form @submit.prevent="submit" id="payman_form">
    <kt-form-section is_first>
        <kt-row>
            <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                    <kt-form-label for="farsi_name">
                        {{ $t('label.farsi_name') }}
                    </kt-form-label>
                    <kt-form-control
                        id="farsi_name"
                        name="farsi_name"
                        v-model="form_data.farsi_name"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>

            <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                    <kt-form-label for="english_name">
                        {{ $t('label.english_name') }}
                    </kt-form-label>
                    <kt-form-control
                        id="english_name"
                        name="english_name"
                        v-model="form_data.english_name"
                        dir="ltr"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
        </kt-row>
        <kt-row>
            <div class="col-12">
                <kt-form-group>
                    <kt-form-label for="category_code">
                        {{ $t('label.subcategory_code') }}
                    </kt-form-label>
                    <select
                        id="category_code"
                        name="category_code"
                        v-model="form_data.category_code"
                        class="form-control kt-selectpicker"
                    >
                        <option 
                            v-bind:key="category.key"
                            v-for="category in categories"

                            :value="category.key"
                        >
                            {{ category.value }}
                        </option>
                    </select>
                </kt-form-group>
            </div>
        </kt-row>
        <kt-row>
            <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                    <kt-form-label for="address">
                        {{ $t('label.address') }}
                    </kt-form-label>
                    <select
                        v-if="addresses"
                        id="address"
                        name="address"
                        v-model="form_data.address"
                        class="form-control kt-selectpicker"
                    >
                        <option 
                            v-bind:key="address.id"
                            v-for="address in addresses"

                            :value="address.id"
                        >
                            {{ address.address }}
                        </option>
                    </select>
                </kt-form-group>
            </kt-col>
            <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                    <kt-form-label for="phone_number">
                        {{ $t('label.telephone') }}
                    </kt-form-label>
                    <kt-form-control
                        dir="ltr"
                        id="phone_number"
                        name="phone_number"
                        v-model="form_data.phone_number"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
        </kt-row>
        <kt-row>
            <kt-col xs="12">
                <kt-form-group>
                    <kt-form-label for="sheba_number">
                        {{ $t('label.sheba_number') }}
                    </kt-form-label>
                    <select
                        id="sheba_number"
                        name="sheba_number"
                        v-model="form_data.sheba_number"
                        class="form-control kt-selectpicker"
                    >
                        <option 
                            v-bind:key="sheba_number.id"
                            v-for="sheba_number in sheba_numbers"

                            :value="sheba_number.id"
                        >
                            {{ sheba_number.number }}
                        </option>
                    </select>
                </kt-form-group>
            </kt-col>
        </kt-row>
    </kt-form-section>
    
    <kt-form-section>
        <kt-row>
            <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                    <kt-form-label for="website_address">
                        {{ $t('label.site_address') }}
                    </kt-form-label>
                    <kt-form-control
                        dir="ltr"
                        id="website_address"
                        name="website_address"
                        placeholder="https://mysite.ir/"
                        v-model="form_data.website_address"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
            <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                    <kt-form-label for="server_ip">
                        {{ $t('label.server_ip') }}
                    </kt-form-label>
                    <kt-form-control
                        dir="ltr"
                        id="server_ip"
                        name="server_ip"
                        v-model="form_data.server_ip"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
        </kt-row>
    </kt-form-section>

    <kt-form-section>
        <kt-row>
            <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                    <kt-form-label for="wage">
                        {{ $t('label.wage') }}
                    </kt-form-label>
                    <select
                        id="wage"
                        name="wage"
                        @change="selectChange(false)"
                        class="form-control kt-selectpicker"
                    >
                        <option
                            v-for="wage in wages"
                            v-bind:key="wage.id"
                            :value="wage.id"
                        >
                            {{ wage.value }}
                        </option>
                    </select>
                </kt-form-group>
            </kt-col>

            <kt-col id="merchant_wage_share_column" lg="3" md="3" xs="12">
                <kt-form-group>
                    <kt-form-label for="merchant_wage_share">
                        {{ $t('label.merchant_wage_share') }}
                    </kt-form-label>
                    <input
                            type="number"
                            max="100"
                            min="0"
                            id="merchant_share_percent"
                            name="merchant_share_percent"
                            v-model="form_data.merchant_share_percent"
                            class="form-control kt-selectpicker"
                            @change="changeWagePercent"
                    >
                </kt-form-group>
            </kt-col>

            <kt-col id="client_wage_share_column" lg="3" md="3" xs="12">
                <kt-form-group>
                    <kt-form-label for="client_share_percent">
                        {{ $t('label.client_wage_share') }}
                    </kt-form-label>
                    <input
                            type="number"
                            max="100"
                            min="0"
                            id="client_share_percent"
                            name="client_share_percent"
                            disabled
                            v-bind:value="100 - form_data.merchant_share_percent"
                            class="form-control kt-selectpicker"
                    >
                </kt-form-group>
            </kt-col>
            <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                    <kt-form-label>
                        {{ $t('label.logo') }}
                    </kt-form-label>
                    <kt-form-label for="logo_file" class="d-block btn btn-secondary btn-wide label-file">
                        <kt-icon type="fa" name="paperclip"></kt-icon>
                        {{ $t('gateway.btn.click_me') }}
                    </kt-form-label>
                        <input
                            @change="processLogoFile"
                            type="file"
                            class="custom-file-upload"
                            name="logo"
                            id="logo_file"
                            accept="image/png"
                        />
                </kt-form-group>
            </kt-col>
        </kt-row>
        <input type="hidden" name="merchant_wage" id="merchant_wage">
    </kt-form-section>

    <kt-form-action class="mt-4">
        <kt-button 
            class="m-2"
            size="md"
            variant="success"
            type="submit"
            v-bind:wide="true"
            id="submit_btn"
        >
            {{ $t('panel.profile.update.wizard.form.btn.submit') }}
        </kt-button>
    </kt-form-action>
</form>
</template>

<script>
import { subcategories } from '@/constants/subcategories'
import $ from 'jquery'
import Inputmask from 'inputmask'
import { mapGetters, mapState } from 'vuex'
import { i18n } from '@/plugins/i18n'

export default {
    props: {
        submit: {
            default: () => { return },
            type: Function
        },
        form_data: {
            default() {
                return {}
            },
            type: Object
        }
    },
    data() {
        return {
            categories: subcategories,
            wages: [
                {
                    id: 0,
                    value: this.$t('gateway.wages.from_payer')
                },
                {
                    id: 100,
                    value: this.$t('gateway.wages.from_me')
                },
                {
                    id: 50,
                    value: this.$t('gateway.wages.half')
                }
            ]
        }
    },
    mounted() {
        this.$store.dispatch('shebaNumber/fetch')
        .finally(() => {
            Object.keys(this.sheba_numbers).map(key => {
                let number = this.sheba_numbers[key]['number'] == null ? '' : 'IR'+this.sheba_numbers[key]['number'].split('-').join('')
                this.sheba_numbers[key]['number'] = number
            })
        })
        this.$store.dispatch('address/fetch').finally(() => {
            this.afterDispatch()
        })
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })

            document.getElementById('phone_number') && Inputmask('099-99999999').mask(document.getElementById('phone_number'))

            let selected_option = 0
            if (
                this.form_data.merchant_share_percent == 0
                || this.form_data.merchant_share_percent == 100
            ) {
                selected_option = this.form_data.merchant_share_percent
            }

            else if (this.form_data.merchant_share_percent == null)
                selected_option = ''
            else {
                selected_option = 50
            }

            $("#wage").val(selected_option).change();

            this.selectChange(true)
        },
        processLogoFile(e) {
            this.form_data.logo = event.target.files[0]
        },
        selectChange(is_first){
            let merchant_wage_share_column = $('#merchant_wage_share_column')
            let client_wage_share_column = $('#client_wage_share_column')
            let merchant_share_percent = $('#merchant_share_percent')
            let client_share_percent = $('#client_share_percent')
            let merchant_wage = $('#merchant_wage')
            let wage = $("#wage")

            if (wage.val() == 0) {
                merchant_wage_share_column.css("display", "none");
                client_wage_share_column.css("display", "none");
                merchant_share_percent.val(0);
                client_share_percent.val(100);
                merchant_wage.val(0);
            } else if (wage.val() == 100) {
                merchant_wage_share_column.css("display", "none");
                client_wage_share_column.css("display", "none");
                merchant_share_percent.val(100);
                client_share_percent.val(0);
                merchant_wage.val(100);
            } else {
                merchant_wage_share_column.css("display", "block");
                client_wage_share_column.css("display", "block");
                if (!is_first) {
                    merchant_share_percent.val(50);
                    client_share_percent.val(50);
                    merchant_wage.val(50);
                } else {
                    merchant_wage.val(merchant_share_percent.val());
                }
            }
        },
        changeWagePercent() {
            let merchant_share_percent = $('#merchant_share_percent')
            let merchant_wage = $('#merchant_wage')
            let wage = $("#wage")

            if (
                merchant_share_percent.val() != 0 ||
                merchant_share_percent.val() != 100
            ) {
                merchant_wage.val(merchant_share_percent.val())
            } else {
                merchant_wage.val(wage.val())
            }
        },
    },
    computed: {
        ...mapGetters('address', [
            'addresses'
        ]),
        ...mapGetters('shebaNumber', [
            'sheba_numbers'
        ])
    },
}
</script>

<style scoped>
.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}
input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}
</style>